<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: `SettingsMakers`,
};
</script>

<style lang="scss">
</style>
